import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import styles from './Sidebar.module.scss';

interface SidebarProps {
    isMobileOpen: boolean;
    onMobileClose: () => void;
}

const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: 'grid_view' },
    { path: '/india', label: 'India Portfolio', icon: 'currency_rupee' },
    { path: '/us', label: 'US Assets', icon: 'attach_money' },
    { path: '/canada', label: 'Canada Wealth', icon: 'maple' },
    { path: '/aggregated', label: 'Aggregated View', icon: 'analytics' },
];

const bottomItems = [{ path: '/support', label: 'Support', icon: 'help_outline' }];

export function Sidebar({ isMobileOpen, onMobileClose }: SidebarProps) {
    const { signOut } = useAuth();
    return (
        <aside className={`${styles.sidebar} ${isMobileOpen ? styles.mobileOpen : ''}`}>
            <div className={styles.brand}>
                <div className={styles.logo}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <circle cx="14" cy="14" r="12" stroke="currentColor" strokeWidth="2" />
                        <path d="M8 14h12M14 8v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <div className={styles.brandText}>
                    <span className={styles.brandName}>Vault Global</span>
                    <span className={styles.brandSub}>Global Inventory</span>
                </div>
            </div>

            <nav className={styles.nav}>
                <ul className={styles.navList}>
                    {navItems.map((item) => (
                        <li key={item.path}>
                            <NavLink
                                to={item.path}
                                className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
                                onClick={onMobileClose}
                            >
                                <span className={styles.navIcon}>
                                    {item.icon === 'grid_view'
                                        ? '◫'
                                        : item.icon === 'currency_rupee'
                                          ? '₹'
                                          : item.icon === 'attach_money'
                                            ? '$'
                                            : item.icon === 'maple'
                                              ? '🍁'
                                              : '📊'}
                                </span>
                                <span className={styles.navLabel}>{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className={styles.bottomSection}>
                <ul className={styles.navList}>
                    {bottomItems.map((item) => (
                        <li key={item.path}>
                            <NavLink
                                to={item.path}
                                className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
                                onClick={onMobileClose}
                            >
                                <span className={styles.navIcon}>?</span>
                                <span className={styles.navLabel}>{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                    <li>
                        <button className={styles.navItem} onClick={signOut}>
                            <span className={styles.navIcon}>⏻</span>
                            <span className={styles.navLabel}>Sign Out</span>
                        </button>
                    </li>
                </ul>
            </div>
        </aside>
    );
}
